/** Must match backend STORAGE_MAX_UPLOAD_BYTES (default 15 MB). */
export const MAX_IMAGE_UPLOAD_BYTES = 15 * 1024 * 1024;

export function formatMaxUploadMegabytes() {
  return Math.round(MAX_IMAGE_UPLOAD_BYTES / (1024 * 1024));
}

export function validateImageUploadSize(file) {
  if (!file) {
    return null;
  }
  if (file.size > MAX_IMAGE_UPLOAD_BYTES) {
    return `Image is too large. Maximum upload size is ${formatMaxUploadMegabytes()} MB.`;
  }
  return null;
}
